import { FORM_STATES } from '@bingads-webui-fluent-component/form';
import { isSDK } from '@bingads-webui-campaign-react/sdk-utils';
import { PMAX_LITE_WIZARD_STEP_PATHS } from '@bingads-webui-campaign-react/pmax-lite-wizard-utils';

const DelayedWebsiteStepWithI18n =
  () => import(/* webpackChunkName: 'website-step.async' */'./website-step')
    .then(({ WebsiteStepWithI18n }) => WebsiteStepWithI18n);

const DelayedWebsiteLazyRepository =
  () => import(/* webpackChunkName: 'website-step.async' */'./website-lazy-repository')
    .then(({ WebsiteLazyRepositoryWithI18n }) => WebsiteLazyRepositoryWithI18n);

const DelayedSDKWebisteLazyRepository =
    () => import(/* webpackChunkName: 'website-step.async' */'./website-lazy-repository')
      .then(({ SDKWebsiteLazyRepositoryWithI18n }) => SDKWebsiteLazyRepositoryWithI18n);

export const WebsiteStepConfig = {
  id: PMAX_LITE_WIZARD_STEP_PATHS.WEBSITE,
  view: DelayedWebsiteStepWithI18n,
  repository: isSDK() ? DelayedSDKWebisteLazyRepository : DelayedWebsiteLazyRepository,
  machineOptions: {
    initialState: FORM_STATES.FETCHING,
    guards: {
      needsConfirming: () => true,
    },
  },
};
